import { IBondGrossMarketReport } from 'services/bonds-helper';

export const PREFIX = 'REPORT_GROSS_YIELD_LINKED_MARKET';

export type IReportGrossYieldLinkedMarketItem = IBondGrossMarketReport & { __isSelected: boolean };
